<template>


  <div v-if="ready">
    <notifications/>
    <router-view/>
  </div>
  <div v-else class="d-flex justify-content-center align-items-center min-vh-100 bg-dark-green">
    <div class="text-center" v-if="ApiPingError">
      <h1 class="text-danger"> Zkuste obnovit stránku!</h1>
    </div>
    <div class="text-center" v-else>
      <div class="spinner-border text-light" role="status" aria-hidden="true"></div>
      <h2 class="h5 fw-semibold mt-3 text-white">objednávky.girafruit.cz</h2>
      <p class="text-white-50" v-if="ApiIsSleeping">Probouzení služby...</p>
      <p class="text-white-50" v-else>Načítání...</p>
    </div>
  </div>



</template>

<script>
import Notifications from "@/components/notifications.vue";
import * as Sentry from "@sentry/vue";
import {watch} from 'vue';
import {
  useAppStore,
} from "@/stores/appStore"
import {useAuth0} from '@auth0/auth0-vue';
import {useRouter} from "vue-router";
import {useNotificationStore} from "@/stores/notificationStore";
import axios from "axios";

export default {
  components: {Notifications},
  setup() {

  },
  data() {
    return {
      appStore: useAppStore(),
      ApiPingRetries: 0,
      ApiPingMaxRetries: 30,
      ApiPingError: false,
      ApiIsSleeping: false,
      ready: false,
      notificationStore: useNotificationStore(),
    };
  },
  methods: {
    // async pingApi() {
    //   console.log("pinging api");
    //   if(this.ApiPingRetries >= this.ApiPingMaxRetries){
    //     this.ApiPingError = true;
    //     return;
    //   }
    //   this.ApiPingRetries++;
    //   await axios.get(import.meta.env.VITE_API_URL,{
    //     validateStatus: (status) => {
    //       // console.log("status",status)
    //       return status >= 200 && status < 500;
    //     }
    //   }).then(async res => {
    //     // console.log("then",res)
    //     this.ApiIsSleeping = false;
    //     await this.waitForApisReady()
    //   }).catch(e => {
    //     // console.log("catch", e)
    //     this.ApiIsSleeping = true;
    //     setTimeout( ()=>{
    //           this.pingApi()
    //     }, 1000);
    //   });
    // },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async pingApi() {
      console.log("pinging api");

      while (this.ApiPingRetries < this.ApiPingMaxRetries) {
        this.ApiPingRetries++;

        try {
          const res = await axios.get(import.meta.env.VITE_API_URL, {
            timeout: 8000,
            validateStatus: status => status >= 200 && status < 500,
          });

          this.ApiIsSleeping = false;
          await this.waitForApisReady();

          return true;

        } catch (e) {
          // network error / timeout / 5xx
          this.ApiIsSleeping = true;
          await this.sleep(1000);
        }
      }

      this.ApiPingError = true;
      return false;
    },
    async waitForApisReady(){
      await this.$apisReady.catch(e=>{
        console.log("catch apis ready");
        this.appStore.auth0.loginWithRedirect();
      })
      this.ready = true;
      console.log("APIs are ready, rendering app...");
    },
    resolveConfiguredProjectId() {
      const configuredProjectId = import.meta.env.VITE_PROJECT_ID || import.meta.env.VITE_GIRA_PROJECT_ID;
      if (typeof configuredProjectId !== "string") {
        return undefined;
      }

      const normalized = configuredProjectId.trim();
      return normalized.length > 0 ? normalized : undefined;
    }
  },
  async created() {
    this.notificationStore.notify = this.$notify;
  },
  async mounted() {
    console.log("mounted");
    const {getAccessTokenSilently, checkSession, loginWithRedirect} = useAuth0();
    const appStore = useAppStore();
    const router = useRouter();

    const loadUserData = async () => {
      try {
        const token = await getAccessTokenSilently();
        // console.log(token);
        if (!token) {
          await appStore.logout();
          return;
        }

        await checkSession();

        await this.$apisReady;
        // console.log("managers ready");

        // stažení mongo user
        appStore.mongoUser = await this.$usersApi.getMe().then(response => response.data)

        // identifikace uživatele pro Sentry (předvyplní feedback widget, breadcrumbs, atd.)
        Sentry.setUser({
          id: appStore.mongoUser._id,
          email: appStore.mongoUser.email,
          username: appStore.mongoUser.name,
        });


        // projekty vždy načteme z API, aby onboarding změny byly okamžitě vidět
        appStore.projects = await this.$usersApi.getUsersProjects().then(response => response.data);

        const configuredProjectId = this.resolveConfiguredProjectId();
        appStore.selectedProject = appStore.projects.find(project => project._id === configuredProjectId) || null;

        // fallback: pokud není nastaven env a uživatel má jeden projekt, vezmeme ho
        if (!appStore.selectedProject && appStore.projects.length === 1) {
          appStore.selectedProject = appStore.projects[0];
        }

        if (!appStore.selectedProject) {
          appStore.customer = null;
          return;
        }

        // pokusím se najít customer dle emailu
        appStore.customer = await this.$customersApi.findCustomerByEmail(
            appStore.selectedProject.spaceId,
            appStore.selectedProject._id,
            appStore.mongoUser.email
        ).then(response =>{
          return response.data
        }).catch(() => {
          return null;
        })

        // pokud customer ještě neexistuje, vytvoří se podle aktuálně přihlášeného uživatele
        if(!appStore.customer){
          const newCustomer = {
            name: appStore.mongoUser.email,
            email: appStore.mongoUser.email
          }
          await this.$customersApi.createCustomer(
            appStore.selectedProject.spaceId,
            appStore.selectedProject._id,
            newCustomer
          ).then(response => {
            appStore.customer = response.data;
          }).catch(e=>{
            console.log(e);
          });
        }

      } catch (error) {
        console.error(error);
      }
    };


    if (appStore.isAuthenticated) {

      await this.pingApi();
      console.log("afterPingAPi");
      await loadUserData();

      // pokud je uživatel přihlášený a je na homepage, přesměrovat na poslední vybraný projekt
      if (appStore.selectedProject && router.currentRoute.value.path === '/') {
        await router.push({name: 'order'});
      }
    } else {
      console.log("is not authenticated");
      await loginWithRedirect();
      appStore.resetStore();
    }

    watch(() => appStore.isAuthenticated, async (newValue) => {
      if (newValue) {
        console.log("authenticated new value");
        await loadUserData();
        if (appStore.selectedProject && router.currentRoute.value.path === '/') {
          await router.push({name: 'order'});
        }
      } else {
        console.log("is not authenticated");
        await loginWithRedirect();
        appStore.resetStore();
      }
    })
  }


};
</script>

